import { CorpPointOfContactFieldsModel } from '../../../../../../styledComponents/Forms/CorpPointOfContactsForm/CorpPointOfContactForm/corpPointOfContact.models';

export const EDIT_CONTACT_MODAL_NAME = 'EDIT_CONTACT_MODAL_NAME';

export const EditContactModalReadOnlyFields: string[] = [
  CorpPointOfContactFieldsModel.emailAddress,
  CorpPointOfContactFieldsModel.firstName,
  CorpPointOfContactFieldsModel.lastName,
];
